import React from 'react'
import {Icon} from '@chakra-ui/react'

const BeveragesIcon = (props) => {
    return (
        <Icon viewBox="0 0 24 24" {...props}>
            <path
                d="M17.7801 2H6.00011C5.93011 2 5.86011 2 5.79011 2.01C4.70011 2.13 3.90011 3.11 4.01011 4.21L5.69011 20.32C5.85011 21.85 7.13011 23.01 8.67011 23.01H15.0901C16.6301 23.01 17.9101 21.86 18.0701 20.32L19.7601 4.22C19.7601 4.15 19.7701 4.08 19.7701 4C19.7801 2.9 18.8801 2 17.7801 2ZM17.7801 4L17.0001 11.38C15.6201 12.24 13.8101 12.19 12.4901 11.2C10.8001 9.93 8.58011 9.69 6.67011 10.45L6.00011 4H17.7801ZM15.0901 21H8.68011C8.17011 21 7.74011 20.62 7.69011 20.11L6.90011 12.55C8.27011 11.76 10.0101 11.84 11.3001 12.8C12.3601 13.59 13.6301 13.99 14.9001 13.99C15.5301 13.99 16.1601 13.89 16.7701 13.69L16.1001 20.1C16.0501 20.61 15.6201 20.99 15.1001 20.99L15.0901 21Z"
                fill="currentColor"
            />
        </Icon>
    )
}

export default BeveragesIcon
